import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=bab987d6&scoped=true&"
import script from "./confirmDialog.vue?vue&type=script&lang=js&"
export * from "./confirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab987d6",
  null
  
)

export default component.exports